module.exports = __webpack_public_path__ + "media/images/logo_nikkei-0b57265f20fe7763c01c1a5ba322b318.png";